import * as React from "react";

import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSecondaryButton } from "uitk-react-button";

import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";

import { HotelAffinityFilterProps } from "src/components/flexComponents/Hotels/typings";

import { useLocalization } from "@shared-ui/localization-context";

interface FilterPill {
  label: string;
  queryFilter: string;
  key: string;
}

export const HotelAffinityFilter: React.FC<HotelAffinityFilterProps> = props => {
  const ButtonTracked = FlexClickTracker(UitkSecondaryButton);
  const { formatText } = useLocalization();

  const filterPills: FilterPill[] = [
    {
      label: formatText("themeSelector.affinity.spa"),
      queryFilter: "&amenities=POOL&amenities=SPA_ON_SITE",
      key: "affinity-filter-spa"
    },
    {
      label: formatText("themeSelector.affinity.waterpark"),
      queryFilter: "&amenities=POOL&amenities=WATER_PARK",
      key: "affinity-filter-waterpark"
    },
    {
      label: formatText("themeSelector.affinity.hottub"),
      queryFilter: "&amenities=POOL&amenities=HOT_TUB",
      key: "affinity-filter-hottub"
    },
    {
      label: formatText("themeSelector.affinity.cheap"),
      queryFilter: "&amenities=POOL&sort=PRICE_LOW_TO_HIGH",
      key: "affinity-filter-cheap"
    },
    {
      label: formatText("themeSelector.affinity.familyfriendly"),
      queryFilter: "&amenities=POOL&travelerType=FAMILY",
      key: "affinity-filter-familyfriendly"
    }
  ];

  return (
    <section className="uitk-type-center all-t-margin-four all-t-padding-one all-b-margin-six all-b-padding-one">
      <p className="uitk-type-heading-300 all-b-margin-two">{formatText("hotels.affinity.filter.message")}</p>
      <UitkLayoutFlex space="three" wrap="wrap" justifyContent="center">
        {filterPills.map((pill: FilterPill) => (
          <UitkLayoutFlexItem key={pill.key}>
            <ButtonTracked
              moduleName="Hotels"
              text={pill.label}
              href={props.seeAllLink + pill.queryFilter}
              rfrr={`HotelAffinityFilter.actionLink.${pill.label}`}
              data-testid="affinity-filters"
            />
          </UitkLayoutFlexItem>
        ))}
      </UitkLayoutFlex>
    </section>
  );
};
